import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reusable/Spinner";
import usePostHook from "../../customHooks/usePostHook";
import usePDFPrintHook from "../../customHooks/usePDFPrintHook";
import print from "print-js";

const EditRunsheetComponent = loadable(
  () => import("../../components/Runsheet/EditRunsheet")
);
const EditRunsheet = () => {
  const { id } = useParams()
  const { data, refetch, isLoading } = useGetHook({
    queryKey: [`Runsheet-${id}`],
    url: `${APIS.MANIFEST}${id}/`,
    params: {},
  });



  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: [`manigest-${id}`, "manigest"],
    navigateURL: "",
  });

  const { mutateAsync: toggleMarkAsDone, isLoading: isMarkAsDoneLoading } = usePatchHook({
    queryKey: [`manifest-${id}`, "manifest"],
    navigateURL: "",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.MANIFEST}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  const { mutateAsync: attachConsignmentMutateAsync } = usePostHook({
    queryKey: ["manifest-items"],
    navigateURL: "",
  });

  const handleToggleMarkAsDone = async (values: any, setError: any) => {
    const url = `${APIS.MANIFEST}${id}/`;
    let formData = {
      is_active: false,
    };
    try {
      await toggleMarkAsDone({ url, formData, setError });
      await refetch()
    } catch (err) {
      console.log(err);
    }
  };

  const handleAttachConsignment = async (consignmentId: string) => {
    const url = `${APIS.MANIFEST_ITEMS}`;
    let formData = {
      manifest: id,
      order: consignmentId
    };
    try {
      await attachConsignmentMutateAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  }

  const { mutateAsync: downloadRunsheet, isPostLoading:isPrintLoading } = usePDFPrintHook({
    queryKey: [],
  });

  const handlePrint = async () => {
    const url = `${APIS.MANIFEST}${id}/print-pdf-runsheet/`;
    let formData = {
    };
    try {
      const res = await downloadRunsheet({url, formData});
      const fileURL = URL.createObjectURL(res?.data);
      print(fileURL);
    } catch (err) {
      console.log(err);
    }
  }


  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Runsheet</span>
      </div>
      {isLoading ? <Spinner /> : <EditRunsheetComponent
        isLoading={isPatchLoading}
        data={data}
        handleEdit={handleEdit}
        handleAttachConsignment={handleAttachConsignment}
        handlePrint={handlePrint}
        isPrintLoading={isPrintLoading}
        handleToggleMarkAsDone={handleToggleMarkAsDone}
      />}
    </>
  );
};
export default EditRunsheet;
